import Header from '@component/Header/Header';
import HomeScreen from '@component/HomeScreen/HomeScreen';
import UserNavigation from '@component/UserNavigation/UserNavigation';
import { usePageLayout } from '@hooks/usePageLayout';
import { useSetPermissions } from '@src/hooks/useSetPermissions';
import { Outlet, useLocation } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { sessionSetter } from '@src/utils/storage';
import { useAppSelector } from '@store/hooks';
import { selectUsers } from '@store/slices/users/usersSlice';
import { ContractorFlowNavigation } from '@component/CreateContractorFlow/ContractorFlowNavigation';
import { CONTRACTOR_USER } from '@routes/helpers';
import { DriverChatLauncher } from '@component/DriverChat/DriverChatLauncher/DriverChatLauncher';

const HomeWrapper = () => {
  const location = useLocation();
  const { userType } = useAppSelector(selectUsers);
  const { isExcluded } = usePageLayout();
  useSetPermissions();

  const isHomePage = location.pathname === '/';
  const isTrackPage = location.pathname.startsWith('/track');
  const isContractorCreatePage = location.pathname === '/contractors/create';
  const contractorFlowStep = Number(location.state?.contractorFlowStep) || 1;
  const hideContractorReviewStep = Boolean(
    location.state?.contractorFlowReview?.isNew
  );

  const [isCollapsed, setIsCollapsed] = useState<boolean>(() => {
    return sessionSetter.getItem<boolean>('sidebarCollapsed') ?? false;
  });
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    contentRef.current?.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const handle = () => {
      setIsCollapsed(
        sessionSetter.getItem<boolean>('sidebarCollapsed') ?? false
      );
    };

    window.addEventListener('sidebarCollapsedChange', handle);
    return () => window.removeEventListener('sidebarCollapsedChange', handle);
  }, []);

  return (
    <section
      className={`main_section ${isContractorCreatePage ? 'contractor-flow-page' : ''}`}
      style={isTrackPage ? { padding: '0' } : {}}
    >
      <div
        className={`main__container container ${isExcluded ? 'without_myroom-user' : ''} ${isContractorCreatePage ? 'contractor-flow-layout' : ''}`}
        data-test-id="home-wrapper-container"
      >
        {!isTrackPage &&
          (isContractorCreatePage ? (
            <ContractorFlowNavigation
              className="contractor-flow-navigation--desktop"
              currentStep={contractorFlowStep}
              hideReviewStep={hideContractorReviewStep}
            />
          ) : (
            <UserNavigation />
          ))}
        <div
          className="main_section__central"
          style={
            isTrackPage
              ? { width: '100%', height: 'auto' }
              : isContractorCreatePage
                ? { width: 'calc(100% - var(--user-navigation-width))' }
                : {
                    width: isCollapsed ? 'calc(100% - 100px)' : '',
                  }
          }
          data-test-id="home-wrapper-central"
        >
          {!isTrackPage && <Header />}
          {isContractorCreatePage && (
            <ContractorFlowNavigation
              className="contractor-flow-navigation--responsive"
              currentStep={contractorFlowStep}
              hideReviewStep={hideContractorReviewStep}
            />
          )}
          <div
            ref={contentRef}
            className={`main__content ${isTrackPage ? 'track-full' : ''} ${isContractorCreatePage ? 'contractor-flow-content' : ''}`}
            style={isTrackPage ? { padding: '0' } : {}}
          >
            <Outlet />
            {isHomePage && userType !== CONTRACTOR_USER && <HomeScreen />}
          </div>
        </div>
      </div>
      {!isTrackPage && <DriverChatLauncher />}
    </section>
  );
};

export default HomeWrapper;
